// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"M2-z","displaySixCardTiles":"N2-z"};